
<div class="row plans justify-content-around">
    <div class="col-3">Plan 1</div>
    <div class="col-3">Plan 2</div>
    <div class="col-3">Plan 3</div>
</div>